"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _primitives = _interopRequireDefault(require("../../primitives"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Background = (0, _styledComponents["default"])(_primitives["default"].Flex).withConfig({
  displayName: "background__Background",
  componentId: "sc-xbli1r-0"
})(["background-repeat:no-repeat;background-position:center center;background-size:cover;"]);
Background.displayName = "Modules.Background";
var _default = Background;
exports["default"] = _default;